import { useContext } from "react";

import { HeaderContext } from "../../contexts/corral/corralHeaderContext";

export const useCurrentHeader = () => {
  const context = useContext(HeaderContext);

  if (context === undefined) {
    throw new Error("useCurrentUser must be used within a CurrentUserProvider");
  }

  return context;
};
